/**
 * The period selector shared by the analytics widgets and the dashboard P&L chart. One list, so
 * a period added here reaches every widget and the URL validation at the same time.
 */
export const PERIODS = [
  { value: '7d', label: '7D' },
  { value: '30d', label: '30D' },
  { value: '90d', label: '90D' },
  { value: '1y', label: '1Y' },
  { value: 'all', label: 'All' },
] as const;

export type Period = (typeof PERIODS)[number]['value'];

export const PERIOD_VALUES: readonly Period[] = PERIODS.map((p) => p.value);

export const DEFAULT_PERIOD: Period = '30d';
